// extracted by mini-css-extract-plugin
module.exports = {"details":"MonsterDetails_details__1GfX8"};